import React from 'react'
import { WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import { Table } from 'reactstrap'
import LoadingIndicator from '@/components/LoadingIndicator'
import ChangeItem from './changeItem'

function ChangeRequestDetails ({ changeRequestId, deleteChangeItem, loading, canViewCHR, task }) {
  let changeRequestLoader = null
  return (
    <WhiteBox
      header='Tasks.ChangeRequest'
      buttons={<Button color='success' size='sm' icon='revision' onClick={() => changeRequestLoader.loadData()} />}
    >
      {loading
        ? <LoadingIndicator />
        : <DataLoader
          ref={ref => { changeRequestLoader = ref }}
          dataSource={() => context.api.changeRequestService.getChangeItems(changeRequestId, {})}
          render={x =>
            x.loading
              ? <LoadingIndicator />
              : <Table borderless className='table-in-white-box'>
                <thead>
                  <tr>
                    <th width='20px'>&nbsp;</th>
                    <th><Resx name='Tasks.ChangeItemOperation' /></th>
                    <th><Resx name='Tasks.ChangeItemScope' /></th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {x.data.data.map((item, index) => <ChangeItem key={index} item={item} deleteChangeItem={deleteChangeItem} canViewCHR={canViewCHR} task={task} />)}
                </tbody>
              </Table>
          } />
      }
    </WhiteBox>
  )
}

export {
  ChangeRequestDetails
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/changeRequest.js